import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { INPUTS_PROPS } from "../../../../../enums/Enums";
import Strings from "../../../../../resources/Strings";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { getErrorMessage, isEmail } from "../../../../../utils/FormUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "./LoginForm.module.css";

const ForgetPasswordForm = (props) => {
  const isShowLoadingSpinner = useSelector(
    (state) => state.common.isShowLoadingSpinner
  );

  const [formData, setFormData] = useState({
    email: "",
    isCurrentStepValid: false,
    isStepSubmitted: false,
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    handleCurrentStepValidity(hasError);
  }, [errors]);

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const handleChange = (newProp) => {
    setSuccessMessage("");
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setFormData({ ...formData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    if (formData.isCurrentStepValid) {
      actionsService
        .forgetPassword(formData.email)
        .then((response) => {
          if (response.data.isSuccess) {
            setSuccessMessage(Strings.SUCCESSFULY_EMAIL_SENT);
          } 
        })
        .catch((error) => {});
    }
  };

  const handleRememberedLogin = () => {
    props.handleRememberedLogin();
  };

  return (
    <div className={classes.loginForm}>
      <div className={classes.title}>{Strings.RESET_PASSWORD}</div>
      <div className={classes.subTitle}>
        {Strings.FORGET_PASSWORD_INSTRUCTION}
      </div>
      <form name="ForgetPassword" onSubmit={handleSubmit}>
        <div className={classes.fileds}>
          <TextInput
            label={Strings.INPUT_LABELS.EMAIL}
            id={INPUTS_PROPS.EMAIL}
            value={formData.email}
            isStepSubmitted={formData.isStepSubmitted}
            handleError={handleError}
            onChange={handleChange}
            hasError={!isEmail(formData.email).isValid}
            errorMessage={getErrorMessage(isEmail(formData.email))}
          />
        </div>

        <div className={classes.loginButton}>
          <EllipseButton type="submit">
            {Strings.SEND_FORGET_PASSWORD_EMAIL}
          </EllipseButton>
        </div>

        <Button
          className={classes.forgetPasswordButton}
          onClick={handleRememberedLogin}
        >
          {Strings.REMEMBRED_LOGIN}
        </Button>
      </form>

      {formData.isStepSubmitted && successMessage && (
        <div className={classes.successMessage}>
          <span>{successMessage}</span>
          <br />
          <Button
            disabled={isShowLoadingSpinner}
            className={classes.sendAgainButton}
            onClick={handleSubmit}
          >
            {Strings.SEND_AGAIN}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ForgetPasswordForm;
